<template>
<div class="detail">
	<add v-if="$route.params.mode == 'add'"></add>
	<edit v-if="$route.params.mode == 'edit'"></edit>
</div>
</template>
<script>
import add from '@/components/orderAdd'
import edit from '@/components/orderEdit'
export default {
	name: 'Home',
	data(){
		return{
		}
	},
	components: {
		add,edit
	},
}
</script>
<style lang="less" scoped>
.detail{
	width: 1200px;
	margin: 0 auto;
	padding: 30px 50px;
	background-color: #F8F8F8;
    box-shadow: 0 1px 0 0 rgba(0, 0, 0,.5);
}

</style>
<style lang="less">
.case-form{
	border-radius: 12px;
	/deep/.el-form-item{
		margin-bottom: 15px;
	}
	/deep/.el-form-item__label{
		height: 25px;
		line-height: 25px;
	}
	.el-dialog-body{
		padding: 20px;
	}
	.footer{
		.el-form-item__content{
			text-align: center;
		}
	}
}
</style>